module.exports = __webpack_public_path__ + "static/media/MRJ.00558a27.png";